import React, { useContext, useState } from 'react'
import { Button, Select, Typography, Space, Row, Col, Card } from 'antd'
import { ImWhatsapp } from 'react-icons/im'
import AppContext from '../context/Context'
import backgroundImage from '../images/background.jpeg'
import PropTypes from 'prop-types'

const { Title, Text } = Typography
const { Option } = Select

export default function Main ({ setSearchFilter, setProperties }) {
  const whats = 'https://wa.me/5522999666419?text=Ol%C3%A1,%0A%0AEstou%20interessado(a)%20em%20obter%20mais%20informa%C3%A7%C3%B5es%20sobre%20os%20servi%C3%A7os%20oferecidos%20pela%20sua%20imobili%C3%A1ria.'
  const [modalidade, setModalidade] = useState('venda')
  const [tipo, setTipo] = useState('casa')
  const { filter, loading } = useContext(AppContext)
  const isMobile = window.innerWidth <= 768

  return (
    <div
      id="parallax-bg"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        backgroundPosition: 'center',
        marginTop: 50,
        minHeight: '100vh',
        width: '100vw',
        fontFamily: "'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif",
        position: 'relative'
      }}
    >
      <Row justify="center" style={{ width: '100%' }}>
        <Col xs={22} sm={18} md={14} lg={12} xl={10}>
          <Card
            style={{
              borderRadius: 10,
              textAlign: 'center',
              padding: isMobile ? '0px' : '30px',
              boxShadow: '0 4px 12px rgba(255, 255, 255, 0.3)',
              backgroundColor: 'rgba(255, 255, 255, 0.7)'
            }}
          >
            <Title level={isMobile ? 2 : 1} style={{ color: '#623d19ff', marginTop: 10, textShadow: '2px 2px 4px rgba(122, 122, 122, 0.5)' }}>
              O imóvel ideal está a um clique de você.
            </Title>
            <Space direction="vertical" size="large" style={{ width: '100%', marginTop: 20 }}>
              <Select
                defaultValue="venda"
                style={{ width: '100%' }}
                onChange={(value) => setModalidade(value)}
              >
                <Option value="venda">Comprar</Option>
                <Option value="aluguel">Alugar</Option>
              </Select>

              <Select
                defaultValue="casa"
                style={{ width: '100%' }}
                onChange={(value) => setTipo(value)}
              >
                <Option value="casa">Casa</Option>
                <Option value="galpao">Galpão</Option>
                <Option value="loja">Loja</Option>
                <Option value="terreno">Terreno</Option>
                <Option value="apartamento">Apartamento</Option>
              </Select>

              <Button
                type="primary"
                size="large"
                style={{
                  background: '#3e250bff',
                  width: '100%',
                  border: 'none'
                }}
                loading={loading}
                onClick={() => {
                  const newFilter = `tipo=${tipo}&modalidade=${modalidade}`
                  if (filter !== newFilter) {
                    setProperties([])
                    setSearchFilter(newFilter)
                  }
                }}
              >
                  Encontrar Imóveis
              </Button>
            </Space>

            <Text style={{ display: 'block', marginTop: 20, color: '#623d19ff' }}>
                Explore nosso site e descubra o imóvel perfeito para você e sua família.
            </Text>
          </Card>
        </Col>
      </Row>

      <Button
        type="primary"
        shape="circle"
        size="large"
        style={{
          backgroundColor: '#25D366',
          border: 'none',
          position: 'fixed',
          bottom: 20,
          left: 20,
          zIndex: 1000
        }}
        icon={<ImWhatsapp size={24} />}
        onClick={() => window.open(whats)}
      />
    </div>
  )
}

Main.propTypes = {
  setSearchFilter: PropTypes.func.isRequired,
  setProperties: PropTypes.func.isRequired
}
